import React, { useEffect, useState } from "react";
import {
    collection,
    onSnapshot,
    query,
    orderBy,
    limit
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import "./css/BookmarkPanel.css";

function Skeleton({ height = 40 }) {
    return (
        <div
            style={{
                height,
                borderRadius: 8,
                background: "#f3f4f6",
                marginBottom: 8,
            }}
        />
    );
}

export default function BookmarksPanel({ limitCount = 6 }) {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser?.uid) {
            setItems([]);
            setLoading(false);
            return;
        }

        const q = query(
            collection(db, "users", currentUser.uid, "bookmarks"),
            orderBy("createdAt", "desc"),
            limit(limitCount)
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                const results = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                setItems(results);
                setLoading(false);
            },
            (err) => {
                console.error("Failed to fetch bookmarks", err);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [currentUser, limitCount]);

    const handleClick = (item) => {
        if (item.type === "ai_trip")
            navigate(`/ai/${item.slug}`);

        if (item.type === "guide")
            navigate(`/${item.slug}`);

        if (item.type === "place")
            navigate(`/${item.slug}`);
    };

    return (
        <div className="bookmarks-card">
            <div className="bookmarks-header">
                <h4>Bookmarks</h4>
            </div>

            <div className="bookmarks-list">
                {loading ? (
                    Array.from({ length: 3 }).map((_, i) => (
                        <Skeleton key={i} height={42} />
                    ))
                ) : items.length === 0 ? (
                    <div className="bookmarks-empty">
                        No bookmarks yet.
                    </div>
                ) : (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="bookmark-item"
                            onClick={() => handleClick(item)}
                        >
                            <div className="bookmark-left">
                                <span className="bookmark-title">
                                    {item.title}
                                </span>

                                <span className={`bookmark-pill ${item.type}`}>
                                    {item.type === "guide" && "Guide"}
                                    {item.type === "place" && "Place"}
                                    {item.type === "ai_trip" && "AI Trip"}
                                </span>
                            </div>

                            <span className="bookmark-arrow">→</span>
                        </div>
                    ))

                )}
            </div>
        </div>
    );

}
